/**
 * BLOCK: How-To Schema - Save Block
 */

import classnames from 'classnames';
import { RichText, InnerBlocks } from '@wordpress/block-editor';

export default function save(props) {
	const { attributes, className } = props;

	const {
		/* eslint-disable */
		block_id,
		/* eslint-enable */
		headingTitle,
		headingDesc,
		headingTag,
		timeNeeded,
		time,
		timeIn,
		estCost,
		cost,
		currencyType,
		mainimage,
		toolsTitle,
		stepsTitle,
		materialTitle,
		tools,
		materials,
		schema,
		showTotaltime,
		showEstcost,
		showTools,
		showMaterials,
	} = attributes;

	let urlChk = '';
	let title = '';
	if (
		'undefined' !== typeof attributes.mainimage &&
		null !== attributes.mainimage &&
		'' !== attributes.mainimage
	) {
		urlChk = attributes.mainimage.url;
		title = attributes.mainimage.title;
	}

	let url = '';
	if ('' !== urlChk) {
		const size = attributes.mainimage.sizes;
		const imageSize = attributes.imgSize;

		if (
			'undefined' !== typeof size &&
			'undefined' !== typeof size[imageSize]
		) {
			url = size[imageSize].url;
		} else {
			url = urlChk;
		}
	}

	let imageIconhtml = '';

	if (mainimage && mainimage.url) {
		imageIconhtml = (
			<img
				className="wpsp-howto__source-image"
				src={url}
				title={title}
				alt=""
			/>
		);
	}
	// Escape </script> sequences to prevent breaking out of the script tag.
	const safeSchema = schema
		? schema.replace(/<\/script>/gi, '<\\/script>')
		: '';

	return (
		/* eslint-disable */
		<div className={classnames(className, `wpsp-block-${block_id}`)} /* eslint-enable */>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: safeSchema }}
			/>
			<div className="wpsp-how-to-main-wrap">
				<div className="wpsp-howto__wrap">
					<RichText.Content
						value={headingTitle}
						tagName={headingTag}
						className="wpsp-howto-heading-text"
					/>
					<RichText.Content
						value={headingDesc}
						tagName="p"
						className="wpsp-howto-desc-text"
					/>
					{mainimage && mainimage.url && (
						<div className="wpsp-howto__source-wrap">
							{imageIconhtml}
						</div>
					)}
					{showTotaltime && (
						<span className="wpsp-howto__time-wrap">
							<RichText.Content
								value={timeNeeded}
								tagName="h4"
								className="wpsp-howto-timeNeeded-text"
							/>
							<RichText.Content
								value={time}
								tagName="p"
								className="wpsp-howto-timeNeeded-value"
							/>
							<RichText.Content
								tagName="p"
								value={timeIn}
								className="wpsp-howto-timeINmin-text"
							/>
						</span>
					)}
					{showEstcost && (
						<span className="wpsp-howto__cost-wrap">
							<RichText.Content
								value={estCost}
								tagName="h4"
								className="wpsp-howto-estcost-text"
							/>
							<RichText.Content
								value={cost}
								tagName="p"
								className="wpsp-howto-estcost-value"
							/>
							<RichText.Content
								tagName="p"
								value={currencyType}
								className="wpsp-howto-estcost-type"
							/>
						</span>
					)}
				</div>
				{showTools && (
					<div className="wpsp-how-to-tools__wrap">
						<RichText.Content
							value={toolsTitle}
							tagName="h4"
							className="wpsp-howto-req-tools-text"
						/>
					</div>
				)}
				{showTools && (
					<div className="wpsp-tools__wrap">
						{tools.map((toolss, index) => {
							return (
								<div
									className={classnames(
										`wpsp-how-to-tools-${index}`,
										'wpsp-how-to-tools-child__wrapper'
									)}
									key={index}
								>
									<div className="wpsp-tools">
										<RichText.Content
											tagName="div"
											value={toolss.add_required_tools}
											className="wpsp-tools__label"
										/>
									</div>
								</div>
							);
						})}
					</div>
				)}
				{showMaterials && (
					<div className="wpsp-how-to-materials__wrap">
						<RichText.Content
							value={materialTitle}
							tagName="h4"
							className="wpsp-howto-req-materials-text"
						/>
					</div>
				)}
				{showMaterials && (
					<div className="wpsp-how-to-materials">
						{materials.map((materialss, index) => {
							return (
								<div
									className={classnames(
										`wpsp-how-to-materials-${index}`,
										'wpsp-how-to-materials-child__wrapper'
									)}
									key={index}
								>
									<div className="wpsp-materials">
										<RichText.Content
											tagName="div"
											value={
												materialss.add_required_materials
											}
											className="wpsp-materials__label"
										/>
									</div>
								</div>
							);
						})}
					</div>
				)}
				<div className="wpsp-how-to-steps__wrap">
					<RichText.Content
						value={stepsTitle}
						tagName="h4"
						className="wpsp-howto-req-steps-text"
					/>
					<div className="wpsp-howto-steps__wrap">
						<InnerBlocks.Content />
					</div>
				</div>
			</div>
		</div>
	);
}
